import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TimeEntryDetailsModal = ({ 
  entry, 
  isOpen, 
  onClose 
}) => {
  if (!isOpen || !entry) return null;

  const formatTime = (timeString) => {
    if (!timeString) return '--:--';
    const [h = '00', m = '00'] = timeString.split(':');
    return `${h.padStart(2, '0')}:${m.padStart(2, '0')}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const [y, m, d] = dateString.split('-');
    if (!y || !m || !d) return dateString;
    return `${d}.${m}.${y}`;
  };

  const formatDurationFromHours = (hours) => {
    if (!hours || hours === 0) return '0h 0m';
    const h = Math.floor(hours);
    const m = Math.round((hours - h) * 60);
    return `${h}h ${m}m`;
  };


  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="bg-card border border-border rounded-lg w-full max-w-4xl max-h-[90vh] overflow-hidden elevation-3">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3">
            <Icon name="Clock" size={24} className="text-primary" />
            <div>
              <h2 className="text-xl font-semibold text-text-primary">
                Zeiteintrag Details
              </h2>
              <p className="text-sm text-text-secondary">
                {entry?.employee?.name} - {formatDate(entry?.date)}
              </p>
            </div>
          </div>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            iconName="X"
            className="touch-feedback"
          />
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[60vh]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Employee Information */}
            <div className="space-y-4">
              <h3 className="text-lg font-medium text-text-primary flex items-center space-x-2">
                <Icon name="User" size={20} className="text-primary" />
                <span>Mitarbeiter Informationen</span>
              </h3>
              
              <div className="bg-muted/30 rounded-lg p-4 space-y-3">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                    <span className="text-sm font-medium text-primary">
                      {entry?.employee?.name?.split(' ')?.map(n => n?.[0])?.join('')}
                    </span>
                  </div>
                  <div>
                    <div className="font-medium text-text-primary">{entry?.employee?.name}</div>
                    <div className="text-sm text-text-secondary">
                      PIN: {entry?.employee?.employee_code || entry?.employee?.id}
                    </div>
                  </div>
                </div>
                
                <div className="grid grid-cols-2 gap-4 pt-3 border-t border-border">
                  <div>
                    <div className="text-xs text-text-secondary">Anstellungsart</div>
                    <div className="font-medium text-text-primary">
                      {entry?.employee?.hire_type || entry?.employee?.hireType || 'N/A'}
                    </div>
                  </div>
                  {/* <div>
                    <div className="text-xs text-text-secondary">Tagesrate</div>
                    <div className="font-medium text-text-primary">
                      €{entry?.employee?.tagesrate || 0}
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            {/* Time Information */}
            <div className="space-y-4">
              <h3 className="text-lg font-medium text-text-primary flex items-center space-x-2">
                <Icon name="Clock" size={20} className="text-primary" />
                <span>Zeit Informationen</span>
              </h3>
              
              <div className="bg-muted/30 rounded-lg p-4 space-y-4">
                <div className="grid grid-cols-1 gap-4">
                  <div>
                    <div className="text-xs text-text-secondary">Datum</div>
                    <div className="font-medium text-text-primary">{formatDate(entry?.date)}</div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 pt-3 border-t border-border">
                  <div>
                    <div className="text-xs text-text-secondary">Kommen</div>
                    <div className="font-medium text-text-primary">
                      {formatTime(entry?.clockIn)}
                    </div>
                    {entry?.originalClockIn && entry?.originalClockIn !== entry?.clockIn && (
                      <div className="text-xs text-text-secondary line-through">
                        Original: {formatTime(entry?.originalClockIn)}
                      </div>
                    )}
                  </div>
                  {/* <div>
                    <div className="text-xs text-text-secondary">Gehen</div>
                    <div className="font-medium text-text-primary">
                      {formatTime(entry?.clockOut)}
                    </div>
                    {entry?.originalClockOut && entry?.originalClockOut !== entry?.clockOut && (
                      <div className="text-xs text-text-secondary line-through">
                        Original: {formatTime(entry?.originalClockOut)}
                      </div>
                    )}
                  </div> */}
                </div>

                <div className="grid grid-cols-2 gap-4 pt-3 border-t border-border">
                  <div>
                    <div className="text-xs text-text-secondary">Dauer</div>
                    <div className="font-medium text-text-primary">
                      {formatDurationFromHours(entry?.dauer || 0)}
                    </div>
                  </div>
                  {/* <div>
                    <div className="text-xs text-text-secondary">Dauer S</div>
                    <div className="font-medium text-text-primary">
                      {formatDurationFromHours(entry?.dauerS || 0)}
                    </div>
                  </div> */}
                </div>

                {/* <div className="grid grid-cols-2 gap-4 pt-3 border-t border-border">
                  <div>
                    <div className="text-xs text-text-secondary">Dauer T</div>
                    <div className="font-medium text-text-primary">
                      {formatDurationFromHours(entry?.dauerT || 0)}
                    </div>
                  </div>
                  <div>
                    <div className="text-xs text-text-secondary">Gehalt S</div>
                    <div className="font-medium text-text-primary">
                      {(() => {
                        const gehaltSValue = (entry?.dauerT || 0) > 0 ? 
                          ((entry?.dauerT - Math.min(Math.floor(entry?.dauerT / 2) * 0.25, 1)) / 8) * (entry?.employee?.tagesrate || 0) : 0;
                        return gehaltSValue > 0 ? `€${gehaltSValue.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '€0,00';
                      })()}
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          {/* Additional Information */}
          <div className="mt-6">
            <h3 className="text-lg font-medium text-text-primary flex items-center space-x-2 mb-4">
              <Icon name="FileText" size={20} className="text-primary" />
              <span>Notizen</span>
            </h3>
            
            <div className="bg-muted/30 rounded-lg p-4">
              <p className="text-text-primary">{entry?.notes || 'Keine Notizen vorhanden'}</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
          >
            Schließen
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TimeEntryDetailsModal;
